var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIkonerUtdanningLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ikoner") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.08,49A11.15,11.15,0,1,1,55.23,37.88,11.16,11.16,0,0,1,44.08,49Zm0-20.49a9.34,9.34,0,1,0,9.34,9.34A9.35,9.35,0,0,0,44.08,28.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M72.73,49A11.15,11.15,0,1,1,83.88,37.88,11.16,11.16,0,0,1,72.73,49Zm0-20.49a9.34,9.34,0,1,0,9.34,9.34A9.35,9.35,0,0,0,72.73,28.54Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 72.72,
    cy: 37.92,
    r: 2.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 44.05,
    cy: 37.92,
    r: 2.62
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M86,30.8a.9.9,0,0,1-.77-.43.92.92,0,0,1,.3-1.25c5.08-3.08,5-11.49,4.83-14.52-4.33,1.93-18,7.45-32.27,7.45a72.47,72.47,0,0,1-31.66-7.4c-1.08,10,4.86,14.26,5.12,14.44a.91.91,0,0,1-1,1.49c-.3-.21-7.24-5.18-5.84-16.51A1.52,1.52,0,0,1,27,12.88a70.31,70.31,0,0,0,31.15,7.36c14.34,0,28-5.69,31.84-7.43a1.51,1.51,0,0,1,2.21,1.31c.3,3.76.33,12.9-5.67,16.55A.85.85,0,0,1,86,30.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M58.42,58.42l-.22-.05c-6.73-1.56-8.85-11-8.93-11.39l-.08-.37.2-.32c2.76-4.22,5.8-6.3,9-6.27,5.18.11,8.7,5.95,8.85,6.19l.17.3-.06.33c-1.76,9.48-8.39,11.44-8.67,11.52ZM51.13,47c.43,1.63,2.46,8.28,7.24,9.59,1.05-.39,5.63-2.46,7.1-9.69-.72-1.09-3.55-5-7.16-5h-.1C55.8,41.83,53.42,43.55,51.13,47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35.1,109l-.55-.62c-.16-.16-15.28-17-17.48-37-1.49-13.54,1.6-24.58,7.5-26.85,3-1.17,8.15-.51,15.18,9.27a.91.91,0,1,1-1.47,1.06c-5-6.9-9.6-10-13.06-8.64-5,1.91-7.7,12.64-6.35,25,1.89,17.32,13.76,32.21,16.47,35.4C51.46,93.64,46,72.4,45.91,72.19a.91.91,0,0,1,1.75-.48c.06.24,6,23.22-11.9,36.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.43,109l-.66-.5c-17.9-13.57-12-36.55-11.9-36.79a.91.91,0,0,1,1.75.48c-.06.21-5.52,21.46,10.57,34.34,2.71-3.19,14.58-18.08,16.47-35.4,1.36-12.32-1.38-23-6.35-25-3.46-1.33-8.1,1.74-13.06,8.64a.91.91,0,1,1-1.47-1.06C84.81,44,89.92,43.32,93,44.48c5.9,2.27,9,13.31,7.5,26.85C98.26,91.4,83.14,108.22,83,108.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M59,108.27a18.92,18.92,0,0,1-15.88-8.6.91.91,0,1,1,1.56-.92A17.1,17.1,0,0,0,59,106.46h.24c9.75-.13,13.45-7.22,13.6-7.52a.91.91,0,0,1,1.62.81c-.17.34-4.31,8.38-15.19,8.52Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIkonerUtdanningLarge);
export default __webpack_public_path__ + "static/media/Ikoner_Utdanning_large.b62a8c396ec65e00f9549bdaaa85132c.svg";
export { ForwardRef as ReactComponent };